import { useState } from "react";
import { useLang } from "../../context/langProvider";
import "./styles.css";
import { useSelector } from "react-redux";
export default function FormActivity({idParentActivity,refresh,open,onClose}){
      const [nameActivity, setNameActivity] = useState("");
      const [loading, setLoading] = useState(false);
      //const [message, setMessage] = useState("");
      const { lang } = useLang();
      const { token } = useSelector((state) => state.auth);

      const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
    
        const formData = new FormData();
        formData.append("nameActivity", nameActivity);
        
        formData.append("idParentActivity", idParentActivity);
        formData.append("lang", lang);
    
        fetch("https://intereseaux-api.bonnardwebeditions.fr/api/activities", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token
          },
          body: formData,
        })
          .then((res) => res.json())
          .then(() => {
            //setMessage("Activité ajoutée !");
            setNameActivity("");
            // Recharge la liste
            refresh();
            onClose();
          })
          .catch((err) => {
            console.error(err);
            //setMessage("Erreur lors de l'ajout.");
          })
          .finally(() => setLoading(false));
      };
        if (!open) return null;

    return(
        <div className="form-activity-backdrop">
            <form className="form-activity" onSubmit={handleSubmit} encType="multipart/form-data">
            <h2>Ajouter une {idParentActivity!=null?"sous ":""} activité</h2>

            <div>
                <label>
                Nom de {idParentActivity!=null?"la sous activité":"l'activité"} :<br/>
                <input
                    type="text"
                    value={nameActivity}
                    onChange={(e) => setNameActivity(e.target.value)}
                    required
                />
                </label>
            </div>
            <div className="form-activity-actions">
                <button onClick={onClose}>ANNULER</button>

                <button className="confirm" type="submit" disabled={loading}>
                    {loading ? "Ajout en cours..." : "AJOUTER"}
                </button>

            </div>
            
            
            </form>
        </div>
    )

}